import React from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleSpinner, toggleModalWithTimer, toggleModal } from 'apps/auth/actions/appAction';
import { toggleChat } from 'apps/auth/actions/chatAction';
import { addExtras } from 'apps/auth/actions/extraAction';
import { Badge } from 'apps/auth/components/common/Badge/Badge';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { IconWrapper, PanelContent, PanelFrame, PanelRightBlock } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import { amplitudeEventForGetCardFromAccount } from 'apps/auth/components/utils/AmplitudeUtils';
import { CARD_MAIN_SCREEN_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { ACCOUNT_CURRENCY, CARD_TYPE, FROM } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { cardType, LINKED_ACCOUNT } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { AUTH_GA_CARD, AUTH_GA_STUB_PAGE, AUTH_GA_VIRTUAL_CARD_CREATE_PREVIEW } from 'apps/auth/constants/UrlConstants';
import { curryRequestsForLinkingCard } from 'apps/auth/services/GaAccountsService';

const GaPocketCardList = (props) => {
    const requestsForLinkingCard = curryRequestsForLinkingCard(
        props.toggleSpinner,
        props.addExtras,
        props.toggleModalWithTimer,
        props.popupRef,
        props.toggleChat,
        props.toggleModal,
        props.messages,
    );

    const amplitudeEventForViewCard = (virtual, code) => {
        amplitude.getInstance().logEvent(CARD_MAIN_SCREEN_SHOWN, {
            [CARD_TYPE]: virtual ? cardType.VIRTUAL : cardType.PLASTIC,
            [ACCOUNT_CURRENCY]: code,
            [FROM]: LINKED_ACCOUNT,
        });
    };

    const getLinkedCardsTitle = () => {
        return (
            <Text variant="div" size="subheader" indent="16px" color="secondary">
                {props.linkedCard}
            </Text>
        );
    };

    if (!props.virtualCard && !props.plasticCard) {
        return (
            <>
                {getLinkedCardsTitle()}

                <Panel
                    type="reactLink"
                    to={AUTH_GA_VIRTUAL_CARD_CREATE_PREVIEW}
                    hasIcon
                    isHoverable
                    negativeMargin
                    onClick={() => {
                        amplitudeEventForGetCardFromAccount();
                    }}
                >
                    <IconWrapper>
                        <Icon name="card-plus" color="primary" />
                    </IconWrapper>
                    <Text color="primary">{props.paysendCard}</Text>
                </Panel>
            </>
        );
    } else if (props.virtualCard || props.plasticCard) {
        const firstLink = () => {
            if (props.plasticCard?.pendingActivation) {
                return (
                    <Panel type="reactLink" to={AUTH_GA_STUB_PAGE} hasIcon isHoverable negativeMargin>
                        <IconWrapper>
                            <Icon name="cardp-full" color="primary" />
                        </IconWrapper>
                        <Text color="primary">{props.plasticCardPendingActivation}</Text>
                    </Panel>
                );
            } else if (!props.hasLinkedPlasticCard && props.plasticCard) {
                return (
                    <Panel
                        type="button"
                        onClick={() => {
                            requestsForLinkingCard(props.plasticCard, props.account, props.relinkedPlasticCard, props.linkFrozenPlastic);
                        }}
                        hasIcon
                        isHoverable
                        negativeMargin
                    >
                        <IconWrapper>
                            <Icon name="cardp-link" color="primary" />
                        </IconWrapper>
                        <Text color="primary">{props.linkPlastic}</Text>
                    </Panel>
                );
            } else if (props.hasLinkedPlasticCard) {
                return (
                    <Panel
                        type="reactLink"
                        to={`${AUTH_GA_CARD}${props.plasticCard?.id}`}
                        hasIcon
                        isHoverable
                        negativeMargin
                        onClick={() => {
                            amplitudeEventForViewCard(false, props.plasticCard.cardPocket.currency.code);
                        }}
                    >
                        <PanelFrame>
                            <IconWrapper>
                                <Icon name="cardp-full" color={props.plasticCard.expired ? 'lightGray' : 'primary'} />
                            </IconWrapper>
                            <PanelContent>
                                <Text
                                    color={props.plasticCard.expired ? 'lightGray' : 'primary'}
                                >{`${props.plastic} ${props.plasticCard?.panGroupLast6Digits}`}</Text>
                            </PanelContent>
                            {props.plasticCard.expired && (
                                <PanelRightBlock>
                                    <Badge caption={props.expired} size="fit" variant="tertiary" />
                                </PanelRightBlock>
                            )}
                        </PanelFrame>
                    </Panel>
                );
            } else {
                return <></>;
            }
        };

        const secondLink = () => {
            if (!props.virtualCard) {
                return (
                    <Panel
                        type="reactLink"
                        to={AUTH_GA_VIRTUAL_CARD_CREATE_PREVIEW}
                        hasIcon
                        isHoverable
                        negativeMargin
                        onClick={() => {
                            amplitudeEventForGetCardFromAccount();
                        }}
                    >
                        <IconWrapper>
                            <Icon name="card-plus" />
                        </IconWrapper>
                        {props.getVirtual}
                    </Panel>
                );
            } else if (!props.hasLinkedVirtualCard) {
                return (
                    <Panel
                        type="button"
                        onClick={() => {
                            requestsForLinkingCard(props.virtualCard, props.account, props.relinkedVirtualCard, props.linkFrozenVirtual);
                        }}
                        hasIcon
                        isHoverable
                        negativeMargin
                    >
                        <IconWrapper>
                            <Icon name="cardp-link" />
                        </IconWrapper>
                        {props.linkVirtual}
                    </Panel>
                );
            } else {
                return (
                    <Panel
                        type="reactLink"
                        to={`${AUTH_GA_CARD}${props.virtualCard?.id}`}
                        hasIcon
                        isHoverable
                        negativeMargin
                        onClick={() => {
                            amplitudeEventForViewCard(true, props.virtualCard.cardPocket.currency.code);
                        }}
                    >
                        <PanelFrame>
                            <IconWrapper>
                                <Icon name="cardp" color={props.virtualCard.expired ? 'superLightGray' : 'primary'} />
                            </IconWrapper>
                            <PanelContent>
                                <Text
                                    color={props.virtualCard.expired ? 'lightGray' : 'primary'}
                                >{`${props.virtual} ${props.virtualCard.panGroupLast6Digits}`}</Text>
                            </PanelContent>
                            {props.virtualCard.expired && (
                                <PanelRightBlock>
                                    <Badge caption={props.expired} size="fit" variant="tertiary" />
                                </PanelRightBlock>
                            )}
                        </PanelFrame>
                    </Panel>
                );
            }
        };

        return (
            <>
                {getLinkedCardsTitle()}
                {firstLink()}
                {secondLink()}
            </>
        );
    }
};
const mapStateToProps = (state) => {
    return {
        virtualCard: state.extra.virtualCard,
        plasticCard: state.extra.plasticCard,
        hasLinkedPlasticCard: state.extra.hasLinkedPlasticCard,
        hasLinkedVirtualCard: state.extra.hasLinkedVirtualCard,
        account: state.extra.account,
        paysendCard: state.messages.pageMessages.paysendCard,
        orderCard: state.messages.pageMessages.orderCard,
        linkPlastic: state.messages.pageMessages.linkPlastic,
        plasticCardPendingActivation: state.messages.pageMessages.plasticCardPendingActivation,
        plastic: state.messages.pageMessages.plastic,
        getVirtual: state.messages.pageMessages.getVirtual,
        linkVirtual: state.messages.pageMessages.linkVirtual,
        virtual: state.messages.pageMessages.virtual,
        relinkedVirtualCard: state.messages.pageMessages.relinkedVirtualCard,
        relinkedPlasticCard: state.messages.pageMessages.relinkedPlasticCard,
        linkFrozenPlastic: state.messages.pageMessages.linkFrozenPlastic,
        linkFrozenVirtual: state.messages.pageMessages.linkFrozenVirtual,
        expired: state.messages.pageMessages.expired,
        messages: state.messages.pageMessages,
    };
};
export default connect(mapStateToProps, { toggleSpinner, addExtras, toggleModalWithTimer, toggleModal, toggleChat })(GaPocketCardList);
